import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContentCenter from "../../../components/screen/common-screen-content-center/commonScreenContentCenter";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import { useNavigate } from 'react-router-dom';
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import NavBarComponent from "../../landing/nav-bar/navBar";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import PasswordInputFull from "../../../components/input/password-input-full/passwordInputFull";
import { displayErrorToast, displaySuccessToast, isEmpty } from "../../../utils/Utils";
import { APP_CONSTANTS, ROUTES } from "../../../utils/AppConstants";
import { employeeLoginRequest, showHideNavMenuOptionPayload } from '../../../redux/user/user.action'

const EmployeeLogin = props => {
    const [isLoading, setLoading] = useState(false)
    let navigate = useNavigate();
    const { user, isLogin, loginErrorData } = useSelector(state => state.user)
    const dispatch = useDispatch()
    const [employeeLoginCode, setEmployeeLoginCode] = useState('')
    const [password, setPassword] = useState('')
    const [showEmailFlow, setShowEmailFlow] = useState(false)
    const [personalEmail, setPersonalEmail] = useState('')

    useEffect(() => {
        dispatch({ type: APP_CONSTANTS.LOGOUT })
        sessionStorage.clear()
    }, [])

    useEffect(() => {
        if (isLogin) {
            setLoading(false)
            displaySuccessToast('Login Successful')
            sessionStorage.setItem(APP_CONSTANTS.USER, JSON.stringify(user.data))
            sessionStorage.setItem(APP_CONSTANTS.USER_TOKEN, JSON.stringify(user.data.authToken))
            dispatch(showHideNavMenuOptionPayload(false))
            if (user.data.userDetails.isDefaultPassword === true) {
                navigate(ROUTES.employee.changePassword, { replace: true })
            } else {
                navigate(ROUTES.employee.selectLocation, { replace: true })
            }
        } else {
            if (loginErrorData) {
                setLoading(false)
                displayErrorToast(loginErrorData.message)
            }
        }
    }, [user, isLogin, loginErrorData])

    const handleLoginClick = () => {
        if (isEmpty(employeeLoginCode)) {
            displayErrorToast('Employee login code cannot be blank')
        } else if (isEmpty(password)) {
            displayErrorToast('Password cannot be blank')
        } else {
            setLoading(true)
            const data = {
                employeeLoginCode: employeeLoginCode,
                password: password
            }
            dispatch(employeeLoginRequest(data))
        }
    }

    return (
        <>
            <NavBarComponent navigate={navigate}
                showHome={true}
                isWhiteBackground={true}
                showBusinessRegistration={true}
                showBusinessLogin={true} />
            <div className='sign-in-parent-container'>
                <div className='sign-in-img-layout-container'>
                    <img src={require('../../../assets/sign-in-banner.jpg')} className='sign-up-img-container' />
                    <img src={require('../../../assets/sign-in-banner-tab.jpg')} className='sign-up-tab-img-container' />
                    {/* <div className="sign-up-brand-label">GOMOBITES</div> */}
                </div>
                <div className='sign-in-content-layout-container'>
                    <div className="sign-in-logo-container">
                        <img src={require('../../../assets/logo_togethra_icon.png')} alt='logo' className="img" />
                    </div>
                    <div className='sign-in-heading'>Login to <span className='sign-in-heading-label'>togethra</span></div>
                    {!showEmailFlow && <div>
                        <FormFieldLabel label='Login with your registered employee credentials' className='sign-in-sub-text-label margin-bottom-10' />
                        <CommonInputFloatFull
                            type='text'
                            id='employeeLoginCode'
                            onChange={e => setEmployeeLoginCode(e.target.value)}
                            placeholder='Login code'
                            value={employeeLoginCode}
                        />
                        {<PasswordInputFull
                            id='password'
                            onChange={e => setPassword(e.target.value)}
                            placeholder='Password'
                            value={password}
                        />}
                        <ButtonRow>
                            <CommonButton label='Login'
                                onClick={() => { handleLoginClick() }}
                            />
                        </ButtonRow>
                    </div>}
                    {showEmailFlow && <div>
                        <FormFieldLabel label='Login with employee personal email' className='sign-in-sub-text-label margin-bottom-10' />
                        <CommonInputFloatFull
                            type='text'
                            id='personalEmail'
                            onChange={e => setPersonalEmail(e.target.value)}
                            placeholder='Personal Email'
                            value={personalEmail}
                        />
                        <ButtonRow>
                            <CommonButton label='Login'
                                onClick={() => { handleLoginClick() }}
                            />
                        </ButtonRow>
                    </div>}
                </div>
            </div>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default EmployeeLogin